import * as React from 'react';
import {Remove} from '@mui/icons-material';
import {Autocomplete, CircularProgress, Divider, TextField} from '@mui/material';
import {ReactComponent as Plus} from "../../assets/img/icons/plus.svg";
import SimpleMap from "../../components/SimpleMap";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {
    setAddressSender,
    setCompanySender,
    setEmailSender,
    setFirstNameSender,
    setLastNameSender,
    setLatSender,
    setLngSender,
    setMobileNumberSender,
    setPhoneNumberSender,
    setPostalCodeSender,
} from "../../redux/singleOrder/sender/actions";
import {
    removeNonNumeric,
    handleCheckAddressWithState,
    useShowMessageComponent,
    handleBorderColor
} from "../../assets/js/main";
import {useSnackbar} from "notistack";
import HandleFetchData from "../../plugin/HandleFetchData";

export default function Sender(props) {
    // جابه جایی بین صفحات در متد ها
    const {t} = useTranslation()
    const dispatch = useDispatch();
    const selector = useSelector((st) => st)
    const {enqueueSnackbar} = useSnackbar();
    const {fetchData} = HandleFetchData()
    const {showMessageComponent} = useShowMessageComponent()

    const [_loading, set_Loading] = React.useState(false);
    const [otherInput, setOtherInput] = React.useState(false);
    const [listAddress, setListAddress] = React.useState([])

    // متد دریافت لیست آدرس های قبلی
    const handleGetPreviousAddress = async (e) => {
        set_Loading(true)
        let fetch = await fetchData('', 'GET', `/FetchAddresses?toSearch=${e}`, '', 'application/json', '', '', '')
        set_Loading(false)
        setListAddress(fetch?.Data || [])
    }

    const handleSetInfoSender = (value) => {
        // if (handleCheckAddressWithState(value?.Address1 || '', selector?.single_sender?.city_name, selector?.single_sender?.state_name)) {
        //     showMessageComponent('آدرس شما با شهر مبدا همخانی ندارد', 'error')
        // } else {
            dispatch(setFirstNameSender(value?.FirstName || ''))
            dispatch(setLastNameSender(value?.LastName || ''))
            // dispatch(setNationalCodeSender(value?.national_code || ''))
            dispatch(setPostalCodeSender(value?.ZipPostalCode || ''))
            dispatch(setEmailSender(value?.email || ''))
            dispatch(setCompanySender(value?.Company || ''))
            dispatch(setMobileNumberSender(value?.PhoneNumber || ''))
            // dispatch(setPhoneNumberSender(value?.phone_no || ''))
            dispatch(setAddressSender(value?.Address1 || ''))
            // dispatch(setCityNameSender(value?.StateProvinceName || ''))
            // dispatch(setCityIDSender(value?.StateProvinceId || ''))
            // dispatch(setStateNameSender(value?.City || ''))
            // dispatch(setStateIDSender(value?.CountryId || ''))
            // dispatch(setLatSender(value?.Lat || ''))
            // dispatch(setLngSender(value?.Lon || ''))
        // }

    }

    return (
        <>
            <div className="senderSingleOrderPage">
                <div className="row">
                    <div className="col-12">
                        <div className="info">
                            <div className="show-map">
                                <h4 className="titleSection">{t("singleOrder.sender.t5")}</h4>

                                {/*<div className="btnGroup_light">*/}
                                {/*  <button type="button" className="btnEmpty" onClick={() => setShowMap(!showMap)}>*/}
                                {/*    <span>{t("singleOrder.sender.t32")}</span>*/}
                                {/*  </button>*/}
                                {/*</div>*/}
                            </div>

                            <div className="inputGroup">
                                <div className="row">

                                    <div className="col-12">
                                        {/*{showMap &&*/}
                                        <div className="maps">
                                            <label className="required">{t("singleOrder.sender.t29")}</label>

                                            <SimpleMap
                                                mapRef="senderMap"
                                                handlerLngFromMap={(event) => dispatch(setLngSender(event))}
                                                handlerLatFromMap={(event) => dispatch(setLatSender(event))}
                                                handlerAddressFromMap={(event, i) => {
                                                    if (
                                                        handleCheckAddressWithState(event, selector?.single_sender?.city_name, selector?.single_sender?.state_name)) {
                                                        showMessageComponent('آدرس شما با شهر مبدا همخانی ندارد', 'error')
                                                    } else {
                                                        dispatch(setAddressSender(event))
                                                    }
                                                }}
                                                lngToMap={selector?.single_sender?.lng}
                                                latToMap={selector?.single_sender?.lat}
                                                coordinates={[
                                                    {
                                                        "pointX": selector?.single_sender?.lat,
                                                        "pointY": selector?.single_sender?.lng
                                                    }
                                                ]}
                                                searchInMap={selector?.single_sender?.address}
                                                cityToMap={selector?.single_sender?.city_name}
                                                stateToMap={selector?.single_sender?.state_name}
                                            />
                                        </div>
                                        {/*}*/}


                                        <label className="required">{t("singleOrder.sender.t20")}</label>
                                        <Autocomplete
                                           className="w-100 mb-2"
                                           inputValue={selector?.single_sender?.address}
                                           noOptionsText={t("autoComplete.t1")}
                                           value={selector?.single_sender?.address}
                                           id="previous-address-sender-1"
                                           ref={props.addressRefSender}
                                           disablePortal
                                           onChange={(e, value, reason) => {
                                             if (reason === 'clear') {
                                               handleSetInfoSender(null)
                                             } else {
                                               handleSetInfoSender(value)
                                             }
                                           }}
                                           options={listAddress || []}
                                           getOptionLabel={(option) => option?.Address1 || ''}
                                           renderOption={(props, option) => <li {...props}
                                                                                key={option?.Id}>{option?.Address1}</li>}
                                           renderInput={(params) =>
                                              <TextField {...params}
                                                         hiddenLabel
                                                         size="small"
                                                         placeholder={t("singleOrder.sender.t16")}
                                                         style={handleBorderColor(selector?.public?.validations?.address_validation_Sender)}
                                                         onChange={event => {
                                                           dispatch(setAddressSender(event.target.value))
                                                           event.target.value?.length >= 3 && handleGetPreviousAddress(event.target.value)
                                                         }}
                                                         InputProps={{
                                                           ...params.InputProps,
                                                           endAdornment: (
                                                              <React.Fragment>
                                                                {_loading ? <CircularProgress style={{margin: '0 5px'}} size={20}/> : null}
                                                                {params.InputProps.endAdornment}
                                                              </React.Fragment>
                                                           ),
                                                         }}
                                              />}
                                        />

                                        {/*<input type="text" autoComplete="on" name="address" ref={props.addressRefSender}*/}
                                        {/*       style={handleBorderColor(selector?.public?.validations?.address_validation_Sender)}*/}
                                        {/*       placeholder={t("singleOrder.sender.t34")}*/}
                                        {/*       value={selector?.single_sender?.address} id="address"*/}
                                        {/*       onChange={e => dispatch(setAddressSender(e.target.value))}/>*/}

                                        {
                                            selector?.public?.validations?.address_validation_Sender &&
                                            <p className="error">{selector?.public?.validations?.address_validation_Sender}</p>
                                        }
                                    </div>

                                    <div className="col-6 col-md-6">
                                        <label className="required">{t("singleOrder.sender.t6")}</label>
                                        <input type="text" autoComplete="on" name="firstName"
                                               ref={props.firstNameRefSender}
                                               style={handleBorderColor(selector?.public?.validations?.firstName_validation_Sender)}
                                               value={selector?.single_sender?.first_name} id="firstName"
                                               onChange={e => dispatch(setFirstNameSender(e.target.value))}/>

                                        {
                                            selector?.public?.validations?.firstName_validation_Sender &&
                                            <p className="error">{selector?.public?.validations?.firstName_validation_Sender}</p>
                                        }

                                    </div>
                                    <div className="col-6 col-md-6">
                                        <label className="required">{t("singleOrder.sender.t7")}</label>
                                        <input type="text" autoComplete="on" name="lastName"
                                               ref={props.lastNameRefSender}
                                               style={handleBorderColor(selector?.public?.validations?.lastName_validation_Sender)}
                                               value={selector?.single_sender?.last_name} id="lastName"
                                               onChange={e => dispatch(setLastNameSender(e.target.value))}/>

                                        {
                                            selector?.public?.validations?.lastName_validation_Sender &&
                                            <p className="error">{selector?.public?.validations?.lastName_validation_Sender}</p>
                                        }
                                    </div>

                                    <div className="col-12 col-md-6">
                                        <label className="required">{t("singleOrder.sender.t8")}</label>
                                        <input type="text" name="mobile" className="numeric" ref={props.mobileRefSender}
                                               style={handleBorderColor(selector?.public?.validations?.mobileNumber_validation_Sender)}
                                               value={selector?.single_sender?.mobile_number} id="mobileNumber"
                                               inputMode='numeric'
                                               onChange={e => e?.target?.value?.length <= 11 &&
                                                   dispatch(setMobileNumberSender(removeNonNumeric(e.target.value)))
                                               }
                                        />
                                        {
                                            selector?.public?.validations?.mobileNumber_validation_Sender &&
                                            <p className="error">{selector?.public?.validations?.mobileNumber_validation_Sender}</p>
                                        }
                                    </div>

                                    <div className="col-12 col-md-6">
                                        <label
                                            className="">{t("singleOrder.sender.t27") + ' ' + t("singleOrder.sender.t33")}</label>
                                        <input type="text" name="postalCode" className="numeric" inputMode='numeric'
                                               ref={props.postalCodeRefSender}
                                               style={handleBorderColor(selector?.public?.validations?.postalCode_validation_Sender)}
                                               value={selector?.single_sender?.postal_code} id="postalCode"
                                               onChange={e => e?.target?.value?.length <= 10 &&
                                                   dispatch(setPostalCodeSender(removeNonNumeric(e.target.value)))
                                               }
                                        />
                                        {
                                            selector?.public?.validations?.postalCode_validation_Sender &&
                                            <p className="error">{selector?.public?.validations?.postalCode_validation_Sender}</p>
                                        }
                                    </div>

                                    <div className="col-12">
                                        <div className="row">
                                            <div className="col-12 col-md-6 d-flex">
                                                <div className="__btnGroup_yellow">
                                                    <button className="btnEmpty"
                                                            onClick={() => setOtherInput(!otherInput)} id="otherInput">
                                                        {otherInput ? <Remove className="minus"/> :
                                                            <Plus className="plus"/>}
                                                        <span>{otherInput ? t("singleOrder.sender.t31") : t("singleOrder.sender.t30")}</span>
                                                    </button>
                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                    {
                                        otherInput && <>
                                            <div className="col-12 col-md-6">
                                                <label className="">{t("singleOrder.sender.t25")}</label>
                                                <input type="text" name="phone" ref={props.phoneRefSender}
                                                       className="numeric"
                                                       style={handleBorderColor(selector?.public?.validations?.phoneNumber_validation_Sender)}
                                                       inputMode='numeric' value={selector?.single_sender?.phone_number}
                                                       id="phoneNumber"
                                                       onChange={e => e?.target?.value?.length <= 11 && dispatch(setPhoneNumberSender(removeNonNumeric(e.target.value)))}
                                                />
                                                {
                                                    selector?.public?.validations?.phoneNumber_validation_Sender &&
                                                    <p className="error">{selector?.public?.validations?.phoneNumber_validation_Sender}</p>
                                                }
                                            </div>

                                            <div className="col-12 col-md-6">
                                                <label>{t("singleOrder.sender.t9")}</label>
                                                <input type="email" name="email" ref={props.emailRefSender} id="email"
                                                       style={handleBorderColor(selector?.public?.validations?.email_validation_Sender)}
                                                       value={selector?.single_sender?.email}
                                                       onChange={e => dispatch(setEmailSender(e.target.value))}/>
                                                {
                                                    selector?.public?.validations?.email_validation_Sender &&
                                                    <p className="error">{selector?.public?.validations?.email_validation_Sender}</p>
                                                }
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <label>{t("singleOrder.sender.t10")}</label>
                                                <input type="text" autoComplete="on" name="company"
                                                       ref={props.companyRefSender}
                                                       style={handleBorderColor(selector?.public?.validations?.company_validation_Sender)}
                                                       value={selector?.single_sender?.company} id="company"
                                                       onChange={e => dispatch(setCompanySender(e.target.value))}/>
                                                {
                                                    selector?.public?.validations?.company_validation_Sender &&
                                                    <p className="error">{selector?.public?.validations?.company_validation_Sender}</p>
                                                }
                                            </div>
                                        </>
                                    }

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12">
                        <Divider/>
                    </div>
                </div>
            </div>
        </>
    )
}
